import { FormField } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useFormsTranslation } from '@/hooks/useTranslation';
import type { Control } from 'react-hook-form';
import { FormFieldWrapper } from '../../FormFieldWrapper';
import type { FormKData } from '../types/formK.types';

interface ControllingOwnerTypeSectionProps {
  control: Control<FormKData>;
}

/**
 * Controlling Owner Type Section Component
 * Renders radio group for selecting how the controlling owner is determined
 */
export function ControllingOwnerTypeSection({
  control,
}: ControllingOwnerTypeSectionProps) {
  const { t: tForms } = useFormsTranslation();

  return (
    <FormField
      control={control}
      name='controllingOwnerType'
      render={({ field, fieldState }) => (
        <FormFieldWrapper
          label={tForms('formK.fields.controllingOwnerType')}
          name='controllingOwnerType'
          required
          error={fieldState.error?.message}
          isGroupLabel={true}
        >
          <RadioGroup
            value={field.value}
            onValueChange={field.onChange}
            className='space-y-3'
          >
            <div className='flex items-start space-x-2'>
              <RadioGroupItem
                value='shares_25_percent'
                id='shares_25_percent'
                className='mt-1'
              />
              <label
                htmlFor='shares_25_percent'
                className='text-sm font-medium leading-relaxed peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer'
              >
                {tForms('formK.labels.shares25Percent')}
              </label>
            </div>
            <div className='flex items-start space-x-2'>
              <RadioGroupItem
                value='control_other_way'
                id='control_other_way'
                className='mt-1'
              />
              <label
                htmlFor='control_other_way'
                className='text-sm font-medium leading-relaxed peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer'
              >
                {tForms('formK.labels.controlOtherWay')}
              </label>
            </div>
            <div className='flex items-start space-x-2'>
              <RadioGroupItem
                value='management_control'
                id='management_control'
                className='mt-1'
              />
              <label
                htmlFor='management_control'
                className='text-sm font-medium leading-relaxed peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer'
              >
                {tForms('formK.labels.managementControl')}
              </label>
            </div>
          </RadioGroup>
        </FormFieldWrapper>
      )}
    />
  );
}
